export const useLocalMock = false;
const constants = require('domuso-constants');

export enum CheckType {
  PERSONAL = constants.check21.CheckType.PERSONAL,
  CERTIFIED = constants.check21.CheckType.CERTIFIED,
}

export enum CheckImageType {
  FRONT = "front",
  BACK = "back",
  MOCK = "mock"
}

export enum CheckSubmitFields {
  PHOTO_FRONT = "photoFront",
  PHOTO_BACK = "photoBack",
  CHECK_TYPE = "checkType",
  AMOUNT = "amount",
  ROUTING_NUMBER = "routingNumber",
  ACCOUNT_NUMBER = "accountNumber",
  CHECK_NUMBER = "checkNumber",
}
